export default "__VITE_ASSET__e455bf68__"